var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-widget',[_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v("\n    "+_vm._s(_vm.scaifeWidgetTitle)+"\n  ")]),_vm._v(" "),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('passage-citation-TOC-widget')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }